/**
 * Datadog Configuration
 *
 * Loads Datadog configuration from environment variables.
 */

interface DatadogEnvConfig {
  clientToken?: string | undefined;
  applicationId?: string | undefined;
  site?: string | undefined;
  service?: string | undefined;
  env?: string | undefined;
  version?: string | undefined;
  sampleRate?: number | undefined;
  enableRum?: boolean | undefined;
}

/**
 * Get Datadog configuration from environment variables
 */
export function getDatadogConfig(): DatadogEnvConfig {
  const clientToken = import.meta.env['VITE_DATADOG_CLIENT_TOKEN'] as string | undefined;
  const applicationId = import.meta.env['VITE_DATADOG_APPLICATION_ID'] as string | undefined;
  const site = (import.meta.env['VITE_DATADOG_SITE'] as string | undefined) || 'datadoghq.eu';
  const service = (import.meta.env['VITE_DATADOG_SERVICE'] as string | undefined) || 'tangi-frontend';
  const env = (import.meta.env.MODE as string | undefined) || 'development';
  const version = import.meta.env['VITE_APP_VERSION'];
  const sampleRateStr = import.meta.env['VITE_DATADOG_RUM_SAMPLE_RATE'] as string | undefined;
  const sampleRate = sampleRateStr
    ? parseInt(sampleRateStr, 10)
    : 100; // Default 100% sample rate
  const enableRum = (import.meta.env['VITE_DATADOG_ENABLE_RUM'] as string | undefined) === 'true';

  return {
    clientToken,
    applicationId,
    site,
    service,
    env,
    version,
    sampleRate,
    enableRum: enableRum && !!applicationId, // Only enable RUM if applicationId is provided
  };
}

/**
 * Check if Datadog is configured
 */
export function isDatadogConfigured(): boolean {
  const config = getDatadogConfig();
  return !!config.clientToken;
}
